import { Injectable } from "@angular/core";

import { DffCookieConsentService } from "@e-forsyning/web-components/shared/dff-cookie-consent";

@Injectable({ providedIn: "root" })
export class ServiceProFunctionalConsentService {
    constructor(private readonly cookieConsentService: DffCookieConsentService) {}

    /** Valgfri funktionel storage (værkvalg, oversigtskort) kræver statistics-samtykke. */
    public hasFunctionalConsent(): boolean {
        return this.cookieConsentService.getCookieConsent().consent.statistics;
    }
}
